export default {"src":"/_next/static/media/mondial-logo-inverted-rgb.5e530b1c.svg","height":575,"width":550,"blurWidth":0,"blurHeight":0};